import { Modal } from '@cian/ui-kit';

interface IModalAuthProps {
  children: JSX.Element;
  open: boolean;
  width?: string;
  onClose: VoidFunction;
}

export const CustomModal: React.FC<IModalAuthProps> = ({ children, open, width, onClose }) => {
  return (
    <Modal width={width} onOpenChange={onClose} open={open}>
      {children}
    </Modal>
  );
};
